@if (!(loading$ | async)) {
  @if ((wikipediaPageView$ | async)?.length != 0) {
    @for (wikipediaPageView of wikipediaPageView$ | async; track wikipediaPageView) {
      @if (wikipediaPageView.url === null || wikiUrl == wikipediaPageView.url) {
        <app-aggregated-amount-item
          name="Wikipedia {{
            wikipediaPageView.lang == null
              ? ''
              : wikipediaPageView.lang.replace('ja', '日本').replace('en', '英語')
          }}"
          account="{{
            wikipediaPageView.searchWords == null ? '' : '（' + wikipediaPageView.searchWords + '）'
          }}"
          icon="./assets/wikipedia.png"
          [amount]="wikipediaPageView.units"
          unit="ページビュー数"
          [rate]="wikipediaPageView.rate"
          [link]="wikipediaPageView.url"
          [hasAmount]="wikipediaPageView.hasUnits"
          [loading]="loading$ | async"
          help="{{
            wikipediaPageView.searchWords
          }} の Wikipedia ページビュー数です。ページビュー数は選択期間内の合計数です。"
          [dataCollections]="dataCollections$ | async"
          [dataCollectLoading]="dataCollectLoading$ | async"
        ></app-aggregated-amount-item>
      }
    }
  } @else {
    <app-aggregated-amount-item
      name="Wikipedia （ - ）"
      icon="./assets/wikipedia.png"
      [amount]=""
      unit="ページビュー数"
      [rate]=""
      [link]=""
      [hasAmount]="false"
      [loading]="loading$ | async"
      help="Wikipedia ページビュー数です。ページビュー数は選択期間内の合計数です。"
      [dataCollections]="dataCollections$ | async"
      [dataCollectLoading]="dataCollectLoading$ | async"
      ></app-aggregated-amount-item
      >
    }
  } @else {
    <app-aggregated-amount-item
      name="Wikipedia （ - ）"
      icon="./assets/wikipedia.png"
      [amount]=""
      unit="ページビュー数"
      [rate]=""
      [link]=""
      [hasAmount]="false"
      [loading]="loading$ | async"
      help="Wikipedia ページビュー数です。ページビュー数は選択期間内の合計数です。"
      [dataCollections]="dataCollections$ | async"
      [dataCollectLoading]="dataCollectLoading$ | async"
      ></app-aggregated-amount-item
      >
    }
